import { render } from "./TheFixedMenu.vue?vue&type=template&id=70547e5e&scoped=true"
import script from "./TheFixedMenu.vue?vue&type=script&lang=js"
export * from "./TheFixedMenu.vue?vue&type=script&lang=js"

import "./TheFixedMenu.vue?vue&type=style&index=0&id=70547e5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Efren Bustos\\source\\repos\\VDAI\\vdai\\ClientApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70547e5e"]])

export default __exports__